export const mockGames = [
  {
    id: 4,
    title: "Š. A. F.",
    gamePath: "s-a-f",
    description: "The school is a biohazard zone. As a special agent, you must not only escape the chaos but also secure the building to prevent a city-wide pandemic. Outmaneuver the walking dead, find key items, and solve environmental puzzles to lock down the school's exits. The fate of the city rests on your ability to break out before the virus gets out.",
    descriptionCz: "Škola je biologicky nebezpečnou zónou. Jako speciální agent musíte nejen uniknout chaosu, ale také zabezpečit budovu, abyste zabránili pandemii v celém městě. Překonejte chodící mrtvoly, najděte klíčové předměty a vyřešte environmentální hádanky, abyste uzavřeli východy ze školy. Osud města závisí na tom, zda se vám podaří uniknout dříve, než se virus dostane ven.",
    genre: "Action adventure",
    genreCz: "Akční adventura",
    platform: "PC, Web",
    releaseDate: "2022",
    locale: "CZ",
    status: "Released",
    statusCz: "Vydáno",
    thumbnail: "https://img.itch.zone/aW1hZ2UvMTUyMjQyNC8yMjU4NTg3Ny5wbmc=/original/ZmvcdV.png",
    gallery: [
      "https://img.itch.zone/aW1hZ2UvMTUyMjQyNC8yMjU4NTg3Ny5wbmc=/original/ZmvcdV.png",
      "https://img.itch.zone/aW1hZ2UvMTUyMjQyNC8yMjU4NTkzOS5wbmc=/original/jMf4Zh.png",
      "https://img.itch.zone/aW1hZ2UvMTUyMjQyNC8yMjU4NTg3Ni5wbmc=/original/qrEOtq.png",
      "https://img.itch.zone/aW1hZ2UvMTUyMjQyNC8yMjU4NTg3OS5wbmc=/original/JKjRL3.png",
      "https://img.itch.zone/aW1hZ2UvMTUyMjQyNC8yMjU4NTg3OC5wbmc=/original/YcFgbs.png"
    ],
    liveDemo: "https://hackingcz.itch.io/saf-spoje",
    wishlist: ""
  },
  {
    id: 5,
    title: "Mechanical World",
    gamePath: "mechanical-world",
    description: "Explore the mechanical world and discover it. Along the way, don't get killed and defeat the king of the world.",
    descriptionCz: "Prozkoumejte mechanický svět a objevujte ho. Cestou se nenechte zabít a porazte krále světa.",
    genre: "Adventure",
    genreCz: "Adventura",
    platform: "Web",
    releaseDate: "2022",
    locale: "EN",
    status: "Released",
    statusCz: "Vydáno",
    thumbnail: "https://img.itch.zone/aW1hZ2UvMjQ2MzYxNy8yMjU4NTY0NS5qcGc=/original/NEqKPZ.jpg",
    gallery: [
      "https://img.itch.zone/aW1hZ2UvMjQ2MzYxNy8yMjU4NTY0NS5qcGc=/original/NEqKPZ.jpg",
      "https://img.itch.zone/aW1hZ2UvMjQ2MzYxNy8yMjU4NTY0NC5qcGc=/original/%2FHQHEQ.jpg",
      "https://img.itch.zone/aW1hZ2UvMjQ2MzYxNy8yMjU4NTY0My5qcGc=/original/py3H2L.jpg"
    ],
    liveDemo: "https://hackingcz.itch.io/mechanical-world",
  },
  {
    id: 1,
    title: "Kletba Vlčího Moru (Curse of the Wolfsbane)",
    gamePath: "kletba-vlciho-moru",
    description: "Experience the thrill of hectic battles and use your movement skills to move lightning fast in this action-packed game. Become a master of your abilities and use them to navigate locations with precision, or use them against powerful enemies.",
    descriptionCz: "Zažij vzrušení hektických soubojů a využívej pohybové schopnosti pro bleskově rychlý přesun v této akcí nabité hře. Staň se mistrem svých schopností a využij je pro precizní průchod lokacemi, nebo je využij v boji proti mocným nepřátelům.",
    genre: "Fantasy adventure",
    genreCz: "Fantasy adventura",
    platform: "PC, Steam",
    releaseDate: "2023",
    locale: "EN, CZ",
    status: "Released",
    statusCz: "Vydáno",
    thumbnail: "https://img.itch.zone/aW1hZ2UvMTcwNTI2Ny8xMDA1NjgzNi5wbmc=/original/Pr3Ozg.png",
    gallery: [
      "https://shared.fastly.steamstatic.com/store_item_assets/steam/apps/2367420/header.jpg?t=1694779318",
      "https://img.itch.zone/aW1nLzEwMDU2Nzk1LnBuZw==/original/Fgxu2A.png",
      "https://img.itch.zone/aW1nLzEwMDU2ODAzLnBuZw==/original/PpYUVs.png",
      "https://img.itch.zone/aW1hZ2UvMTcwNTI2Ny8xMDA1NjgzOC5wbmc=/original/XgjxYg.png",
      "https://img.itch.zone/aW1hZ2UvMTcwNTI2Ny8xMDA1NjgzNy5wbmc=/original/5rmacz.png"
    ],
    liveDemo: "https://store.steampowered.com/app/2367420/Kletba_Vlho_Moru/",
    award: "https://shared.fastly.steamstatic.com/store_item_assets/steam/apps/2367420/extras/8a0e48178f44ed6c63fcf7eecd323847.avif?t=1694779318"
  },
  {
    id: 3,
    title: "Out Of Money",
    gamePath: "out-of-money",
    description: "You are a raccoon who searches the islands looking for chests in which things are hidden. These things you must sell, because along the way you lose money and you must not run out when you run out, so it is the end of the game.",
    descriptionCz: "Jste mýval, který prohledává ostrovy a hledá truhly, v nichž jsou ukryty věci. Tyto věci musíte prodat, protože po cestě přicházíte o peníze a ty vám nesmí dojít, když vám dojdou, tak je konec hry.",
    genre: "Roguelike adventure",
    genreCz: "Roguelike adventura",
    platform: "PC",
    releaseDate: "2022",
    locale: ["EN", "CZ"],
    status: "Released",
    statusCz: "Vydáno",
    thumbnail: "https://img.itch.zone/aW1hZ2UvMTc3MDI1Ni8xMDQwNzI0NC5wbmc=/original/OXRfgT.png",
    gallery: [
      "https://img.itch.zone/aW1hZ2UvMTc3MDI1Ni8xMDQwNzI0NC5wbmc=/original/OXRfgT.png",
      "https://img.itch.zone/aW1hZ2UvMTc3MDI1Ni8xMDQwNzI1My5wbmc=/original/FR%2Fpe6.png",
      "https://img.itch.zone/aW1hZ2UvMTc3MDI1Ni8xMDQwNzIwOS5wbmc=/original/Ir8VBn.png",
      "https://img.itch.zone/aW1hZ2UvMTc3MDI1Ni8xMDQwNzIxMC5wbmc=/original/hXYrGl.png",
      "https://img.itch.zone/aW1hZ2UvMTc3MDI1Ni8xMDQwNzIxMS5wbmc=/original/m2T4yJ.png",
      "https://img.itch.zone/aW1nLzEwNDEwNDkzLnBuZw==/original/dhTQTN.png"
    ],
    liveDemo: "https://hackingcz.itch.io/out-of-money",
  },
  {
    id: 1,
    title: "Tonikum",
    gamePath: "tonikum",
    description: "You play as a young alchemist who embarks on numerous adventures in search of ingredients. Fight fearsome dragons and progress through ever-changing levels.",
    descriptionCz: "Hrajete za mladého alchymistu, který se vydává na četná dobrodružství při hledání ingrediencí. Bojujte se strašlivými draky a procházejte stále se měnícími úrovněmi.",
    genre: "Action adventure",
    genreCz: "Akční adventura",
    platform: "PC, Steam",
    releaseDate: "2027",
    locale: "EN, CZ",
    status: "In Development",
    statusCz: "Ve vývoji",
    thumbnail: "https://img.itch.zone/aW1hZ2UvMjM3OTYxNi8xNDI1NTk1My5wbmc=/original/t%2FWjGa.png",
    gallery: [
      "https://img.itch.zone/aW1hZ2UvMjM3OTYxNi8yNDA1MTUzNy5qcGc=/original/3BLT7P.jpg",
      "https://img.itch.zone/aW1hZ2UvMjM3OTYxNi8xNDI1NTk1My5wbmc=/original/t%2FWjGa.png",
      "https://img.itch.zone/aW1hZ2UvMjM3OTYxNi8xNDI1NTk1NC5wbmc=/original/O5ZY6T.png",
      "https://img.itch.zone/aW1hZ2UvMjM3OTYxNi8xNDI1NTk1Ny5wbmc=/original/h0Fgkt.png",
      "https://img.itch.zone/aW1hZ2UvMjM3OTYxNi8xNDI1NTk2OC5wbmc=/original/OVXOt8.png",
    ],
    wishlist: "https://hackingcz.itch.io/tonikum"
  }
];

export const mockTeam = [
  {
    id: 0,
    name: "Matúš Nagy",
    role: "Game Designer",
    roleCz: "Herní Designér",
    bio: "Designing meaningful gaming experience that engage players and helping the team to create the best game possible.",
    bioCz: "Navrhuje herní zážitek s hlubším významem, který zaujme hráče a pomáhá týmu vytvořit co nejlepší hru.",
    isCore: true,
    initials: "MN",
    links: [
      {
        label: "LinkedIn",
        url: "https://www.linkedin.com/in/matúš-nagy-826b19192"
      },
    ]
  },
  {
    id: 1,
    name: "Dominik Hurta",
    role: "Game Programmer",
    roleCz: "Herní Programátor",
    bio: "Builds responsive game systems and intuitive mechanics that define the core experience of our titles.",
    bioCz: "Vytváří responzivní herní systémy a intuitivní mechaniky, které určují jádro hráčského zážitku našich titulů.",
    isCore: true,
    initials: "DH",
    links: [
      {
        label: "GitHub",
        url: "https://github.com/HackingCZE",
      },
      {
        label: "LinkedIn",
        url: "https://www.linkedin.com/in/dominik-hurta-42ba24225/"
      },
      {
        label: "Portfolio",
        url: "https://www.hurtaweb.cz/"
      },
      {
        label: "Itch_io",
        url: "https://hackingcz.itch.io/"
      }
    ]
  },
  {
    id: 2,
    name: "Kamila Hniličková",
    role: "2D Graphic Designer",
    roleCz: "2D Grafička",
    bio: "Specializes in creating visual assets and making the game feel lively and immersive.",
    bioCz: "Specializuje se na tvorbu vizuálních assetů a stará se o to, aby hra působila živě.",
    isCore: true,
    initials: "KH",
    links: [
      {
        label: "LinkedIn",
        url: "https://www.linkedin.com/in/kamila-hnili%C4%8Dkov%C3%A1-a4597229a/"
      },
    ]
  },
  {
    id: 3,
    name: "PlayerXYZ Music",
    role: "Composer",
    roleCz: "Skladatel",
    bio: "Specialize in creating visual assets and making the game feel alive.",
    bioCz: "Skládá pohlcující soundtracky a dynamické hudební motivy, které umocňují hratelnost i vyprávění příběhu.",
    isCore: false,
    initials: "PM",
    links: [
      {
        label: "YouTube",
        url: "https://www.youtube.com/@PlayerXYZMusic"
      },
      {
        label: "Instagram",
        url: "https://www.instagram.com/playerxyzmusic/"
      }
    ]
  },

];